import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const CourierDelivery: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path d="M18.195 5.79H21.3075V24H2.6925L3.09 5.79H5.58" fill="#DCB080" />
      <path d="M7.77 9.3825V2.1525H5.58V9.3825H7.77Z" fill="#825D38" />
      <path d="M18.195 2.1525H16.08V9.3825H18.195V2.1525Z" fill="#825D38" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.64 16.77C11.64 16.77 8.3025 13.0275 16.8675 10.5975C16.8675 10.5975 17.76 17.1075 12.81 17.4375C12.81 17.4375 11.7675 17.4825 11.6475 16.77H11.64Z"
        fill="#368C25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3678 14.1891L14.3668 14.1899L14.3622 14.1939L14.3425 14.2109C14.3247 14.2263 14.2982 14.2497 14.2638 14.2805C14.195 14.3423 14.0952 14.4341 13.9731 14.5524C13.7288 14.7892 13.3965 15.1311 13.0462 15.55C12.3402 16.3942 11.5843 17.5238 11.3013 18.7193C11.2603 18.8926 11.0865 18.9999 10.9132 18.9588C10.7399 18.9178 10.6327 18.744 10.6737 18.5707C10.9907 17.2312 11.8211 16.0095 12.5514 15.1362C12.9191 14.6964 13.2675 14.338 13.5242 14.0892C13.6527 13.9647 13.7586 13.8673 13.8328 13.8006C13.87 13.7673 13.8992 13.7416 13.9195 13.724L13.943 13.7037L13.9494 13.6982L13.9513 13.6966L13.9519 13.6962C13.9519 13.6961 13.9522 13.6959 14.16 13.9425L13.9519 13.6962C14.0881 13.5814 14.2919 13.5985 14.4066 13.7347C14.5214 13.8709 14.5039 14.0744 14.3678 14.1891Z"
        fill="#010202"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.56 17.61C10.56 17.61 12.39 15.555 7.69501 14.22C7.69501 14.22 7.2075 17.79 9.9225 17.9775C9.9225 17.9775 10.4925 18 10.56 17.61Z"
        fill="#368C25"
      />
      <path
        d="M9.18 16.065C9.18 16.065 10.59 17.2575 10.92 18.645L9.18 16.065Z"
        fill="#4CA83F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93376 15.8567C9.04878 15.7207 9.25227 15.7037 9.38826 15.8188L9.18 16.065C9.38826 15.8188 9.3882 15.8187 9.38826 15.8188L9.38896 15.8194L9.39018 15.8204L9.39411 15.8238L9.40784 15.8356C9.41951 15.8458 9.43614 15.8605 9.4571 15.8794C9.49902 15.9171 9.55838 15.9719 9.63024 16.0417C9.77373 16.1812 9.96827 16.3818 10.1738 16.628C10.5795 17.1139 11.0517 17.8048 11.2338 18.5704C11.275 18.7437 11.1679 18.9175 10.9946 18.9587C10.8213 19 10.6475 18.8929 10.6063 18.7196C10.4583 18.0977 10.0605 17.4986 9.67871 17.0414C9.49049 16.816 9.3119 16.6318 9.18071 16.5043C9.11523 16.4406 9.06185 16.3914 9.02537 16.3585C9.00713 16.3421 8.99314 16.3298 8.984 16.3218L8.97401 16.3132L8.97188 16.3114C8.97185 16.3113 8.97191 16.3114 8.97188 16.3114M8.93376 15.8567C8.81877 15.9927 8.83597 16.1963 8.97188 16.3114L8.93376 15.8567Z"
        fill="#010202"
      />
      <path d="M5.58 2.1525H18.195L16.2 0H7.995L5.58 2.1525Z" fill="#DCB080" />
      <path
        d="M2.6925 24L5.5875 21.1275H18.195L21.3075 24H2.6925Z"
        fill="#825D38"
      />
    </svg>
  );
};

export default CourierDelivery;
